import {PaperSize} from './paperSize'
import {Size} from './size'
import type {Unit} from './unit'

const IN_TO_MM = 25.4
const MM_TO_IN = 1.0 / IN_TO_MM

export interface Dimensions {
  size: Size
  unit: Unit
}

export namespace Dimensions {
  export function convert(dims: Dimensions, toUnit: Unit) {
    if (dims.unit === toUnit) {
      return dims.size
    }

    switch (toUnit) {
      case 'inches':
        return Size.scale(dims.size, MM_TO_IN)
      case 'millimeters':
        return Size.scale(dims.size, IN_TO_MM)
    }
  }

  export function forPaperSize(size: PaperSize): Dimensions {
    switch (size) {
      case 'letter':
        return {size: {width: 8.5, height: 11}, unit: 'inches'}
      case 'legal':
        return {size: {width: 8.5, height: 14}, unit: 'inches'}
      case 'tabloid':
        return {size: {width: 11, height: 17}, unit: 'inches'}
      case 'a3':
        return {size: {width: 297, height: 420}, unit: 'millimeters'}
      case 'a4':
        return {size: {width: 210, height: 297}, unit: 'millimeters'}
      case 'a5':
        return {size: {width: 148, height: 210}, unit: 'millimeters'}
      case 'a6':
        return {size: {width: 105, height: 148}, unit: 'millimeters'}
      case 'a7':
        return {size: {width: 74, height: 105}, unit: 'millimeters'}
      default:
        const height = 8.5 / size.aspectRatio
        const imperialDimensions: Dimensions = {size: {width: 8.5, height: height}, unit: 'inches'}

        // Maintain page size, but respect user locale settings for the dimension units
        return size.unit === 'millimeters'
          ? {size: convert(imperialDimensions, 'millimeters'), unit: 'millimeters'}
          : imperialDimensions
    }
  }
}
